/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import FormDialog from '../../../Components/Modal/modal';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import { fetchEmployeeInfo } from './fetchEmploeeInfo'; 
import {
  DEAL_MANUAL_ASSIGNMENT,
  CANCEL_TEXT,
  ASSIGN_TEXT,
} from '../../../Constants/strings';
import './manualAssignmentModal.scss';
import PropTypes from 'prop-types';
import { ReactComponent as MagnifyingGlass } from '../../../Assets/images/svg/dar_magnify.svg';

const ManualAssignmentForm = ({ modalOpen, handleClose, onAssign }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [fetchError, setFetchError] = useState(false);
  const [loadingEmployeeList, setLoadingEmployeeList] = useState(false);
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm.length >= 3) {
      const fetchOptions = async () => {
        setLoadingEmployeeList(true);
        setFetchError(false);
        setFilteredOptions([]);

        try {
          const sortedUsers = await fetchEmployeeInfo(debouncedSearchTerm);
          const options = sortedUsers.map((employee) => ({
            name: employee.fullName,
            employeeId: employee.employeeId,
            designation: employee.designation,
 photoUrl: employee.photoSignedUrl,
          }));
          setFilteredOptions(options);
          setAutocompleteOpen(true);
        } catch (error) {
          console.error('Error fetching employee options:', error);
          setFetchError(true);
        } finally {
          setLoadingEmployeeList(false);
        }
      };

      fetchOptions();
    } else {
      setFilteredOptions([]);
      setAutocompleteOpen(false);
    }
  }, [debouncedSearchTerm]);

  const handleAssignButtonClick = () => {
    if (selectedEmployee) {
      onAssign(selectedEmployee);
    }
  };

  const handleCancelButtonClick = () => {
    handleClose();
  };

  let noOptionsText = '';
  if (!loadingEmployeeList && filteredOptions.length === 0) {
    noOptionsText = 'No matches found';
  }

  return (
    <div>
      <FormDialog
        title={DEAL_MANUAL_ASSIGNMENT.ASSIGN_PROJECT_FOR_REVIEW}
        open={modalOpen}
        handleClose={handleClose}
        dialogPaperCss="manual-assignment-dialog-paper"
        dialogCss="manual-assignment-dialog"
        dialogBodycontent={
          <div className="manual-assignment-dialog-body">
            {fetchError ? (
              <p className="assignment-dialog-title">
                Unable to get employee details, Please try again...
              </p>
            ) : (
              <div>
                <p className="assignment-dialog-title">
                  {DEAL_MANUAL_ASSIGNMENT.ASSIGN_PROJECT_FOR_PERSON}
                </p>
                <label
                  htmlFor="search-person"
                  className="assign-person-name-label"
                >
                  Assign to a person
                </label>
                <Autocomplete
                  options={filteredOptions}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedEmployee}
                  onChange={(event, newValue) => {
                    setSelectedEmployee(newValue);
                    setSearchTerm('');
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (!event || event.type === 'change') {
                      setSearchTerm(newInputValue);
                    }
                  }}
                  inputValue={
                    selectedEmployee ? selectedEmployee.name : searchTerm
                  }
                  filterOptions={(options) => options}
                  open={autocompleteOpen}
                  onClose={() => setAutocompleteOpen(false)}
                  disableClearable={false}
                  clearOnEscape={true}
                  onClear={() => setSelectedEmployee(null)}
                  loading={loadingEmployeeList}
                  loadingText={
                    <div className="header-employee-loading">
                      <CircularProgress size={24} />
                    </div>
                  }
                  noOptionsText={noOptionsText}
                  renderOption={(props, option) => (
                    <li {...props} className="autocomplete-option">
                      <img
                        src={option.photoUrl || ProfilePicPlaceHolder}
                        alt="Profile Placeholder"
                        style={{
                          width: '30px',
                          height: '30px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          margin: '8px',
                        }}
                        onError={(errorEvent) => {
                          errorEvent.target.onerror = null;
                          errorEvent.target.src = ProfilePicPlaceHolder;
                        }}
                      />

                      <div className="option-details">
                        <div className="option-name">
                          <span className="name-text">{option.name}</span>
                          <span className="emp-id-text">
                            {' '}
                            | {option.employeeId}
                          </span>
                        </div>
                        <div className="option-designation">
                          {Array.isArray(option.designation)
                            ? option.designation.join(', ')
                            : option.designation}
                        </div>
                      </div>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Person"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <MagnifyingGlass
                              style={{ fontSize: '24px', color: '#1b1d1f' }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: '#CAC4CF',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#CAC4CF',
                          },
                        },
                      }}
                    />
                  )}
                />
              </div>
            )}
          </div>
        }
        button1={CANCEL_TEXT}
        button2={ASSIGN_TEXT}
        button2Action={handleAssignButtonClick}
        button1Action={handleCancelButtonClick}
      />
    </div>
  );
};

ManualAssignmentForm.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onAssign: PropTypes.func.isRequired,
};

export default ManualAssignmentForm;